// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1022":"4a7d3652","4033":"cdddf8cb","7325":"6b019966"}[chunkId] + ".chunk.css";
};